'use client';

import { loadHistory, saveHistory } from '../api/storageHistory';
import { storeSearchSuggestion } from '../lib/store';

const HISTORY_LIMIT = 5;

const addItem = (query: string) => {
  if (!query?.trim()) {
    return;
  }

  storeSearchSuggestion.send({
    type: 'addToHistory',
    query
  });

  const state = storeSearchSuggestion.getSnapshot();
  const limitedHistory = state.context.history.slice(0, HISTORY_LIMIT);
  saveHistory(limitedHistory);

  if (state.context.history.length > HISTORY_LIMIT) {
    storeSearchSuggestion.send({
      type: 'set',
      state: { history: limitedHistory }
    });
  }
};

const removeItem = (query: string) => {
  storeSearchSuggestion.send({
    type: 'removeFromHistory',
    query
  });

  const state = storeSearchSuggestion.getSnapshot();
  saveHistory(state.context.history);
};

const clear = () => {
  storeSearchSuggestion.send({
    type: 'clearHistory'
  });
  saveHistory([]);
};

const init = () => {
  const history = loadHistory();
  const limitedHistory = history.slice(0, HISTORY_LIMIT);
  storeSearchSuggestion.send({
    type: 'set',
    state: { history: limitedHistory }
  });
};

export const historyActions = {
  addItem,
  removeItem,
  clear,
  init
};
